import { createSlice } from "@reduxjs/toolkit";
import auditList from "../../../rtk-apis/audit/auditList";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const auditListSlice = createSlice({
  name: "auditListSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(auditList.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(auditList.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(auditList.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default auditListSlice.reducer;
